import { FACETED_NAV_COMPONENT } from '../brands/default/content/helpers';
import { getDefaultSeoText } from './facetedNavigation';
import { hyperLocalSeo } from './hyperLocalSeo';

export const getSeoText = (
  facetedNavigation,
  foundLocationName,
  foundLocationShortName,
  hasLocation,
  isHyperLocal,
  isLocationPage,
  isWellnessPage,
  locations,
  parsed,
  router,
  theme,
) => {
  let seoText = parsed?.defaultItem?.text || parsed?.text;
  let seoTitle =
    parsed?.defaultItem?.categoryName ?? (parsed?.defaultItem?.linkText || '');

  if (isLocationPage) {
    seoTitle = foundLocationName
      ? foundLocationName
      : locations.find(
          (item) => item.shortName.toLowerCase() === router.query.slug[0],
        )?.name ?? ' ';
    seoText = FACETED_NAV_COMPONENT.seoLocationText
      .replace(/##LOCATION##/gm, seoTitle)
      .replace(/##SITE_NAME##/gm, FACETED_NAV_COMPONENT.siteName);
  }

  if (isHyperLocal) {
    const { hyperLocalSeoTitle = '', hyperLocalSeoText = '' } = hyperLocalSeo(
      router,
      facetedNavigation,
    );

    if (hyperLocalSeoTitle && hyperLocalSeoText) {
      seoTitle = hyperLocalSeoTitle;
      seoText = hyperLocalSeoText;
    }
  }

  if (isWellnessPage) {
    seoText = FACETED_NAV_COMPONENT.wellnessSeoText;
    seoTitle = FACETED_NAV_COMPONENT.wellnessSeoTitle;
  }

  if (
    !isLocationPage &&
    !isHyperLocal &&
    !isWellnessPage &&
    hasLocation &&
    foundLocationName
  ) {
    seoTitle = seoTitle + ' in ' + foundLocationName;
  }

  if (!seoText || !seoText.length) {
    seoText = getDefaultSeoText(facetedNavigation);
  }

  if (parsed?.catSeoName) seoTitle = parsed?.catSeoName;

  seoText = seoText
    .replace(new RegExp('wowcher', 'gi'), FACETED_NAV_COMPONENT.siteName)
    .replace(new RegExp('undefined', 'gi'), FACETED_NAV_COMPONENT.siteName);

  return {
    seoText,
    seoTitle,
  };
};
